import { StyleSheet, css } from 'aphrodite/no-important'
import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const classes = StyleSheet.create(styles)

export function FormLabel(
  {
    aphroditeStyles,
    className,
    component: Component,
    cropText,
    htmlFor,
    ...props
  },
  { formFieldId, formLayout, labelWidth }
) {
  props.htmlFor = htmlFor || formFieldId
  props.className = css(
    classes.FormLabel,
    formLayout ? classes['FormLabel--form-layout-' + formLayout] : null,
    cropText ? classes['FormLabel--crop-text'] : null,
    aphroditeStyles
  )
  if (className) {
    props.className += ' ' + className
  }
  if (labelWidth) {
    props.style = {
      width: labelWidth,
      ...props.style,
    }
  }

  return <Component {...props} />
}

const stylesShape = {
  _definition: PropTypes.object,
  _name: PropTypes.string,
}

FormLabel.propTypes = {
  aphroditeStyles: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape(stylesShape)),
    PropTypes.shape(stylesShape),
  ]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  cropText: PropTypes.bool,
}
FormLabel.defaultProps = {
  component: 'label',
}
FormLabel.contextTypes = {
  formLayout: PropTypes.oneOf(['basic', 'horizontal', 'inline']),
  formFieldId: PropTypes.string,
  labelWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default FormLabel
